import { render } from "./BaseModalSelect.vue?vue&type=template&id=12ffc3be"
import script from "./BaseModalSelect.vue?vue&type=script&lang=ts"
export * from "./BaseModalSelect.vue?vue&type=script&lang=ts"
script.render = render

export default script